module.exports = __webpack_public_path__ + "images/img-AocmJir.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/ranks/0.png
// module id = 1757
// module chunks = 0